import Api from '../../library/api';

export const REQUEST_LIVE_BOOKINGS = 'REQUEST_LIVE_BOOKINGS';
export const SET_LIVE_BOOKINGS = 'SET_SCHEDULED_BOOKINGS';

export function getLiveBookings() {
  return dispatch => {

    dispatch({type: REQUEST_LIVE_BOOKINGS});

    Api.post('p/job-summaries', { filter: 'Current' })
      .then(resp => {

        dispatch({
          type: SET_LIVE_BOOKINGS,
          payload: resp.journeyReports
        })

      })

  }
}


// WEBPACK FOOTER //
// ./src/components/live-bookings/live-bookings-actions.js